import { Vector3 } from "three";

export function clamp(value: number, min: number, max: number) {
  return Math.max(min, Math.min(max, value));
}

export function clamp01(x: number) {
  return clamp(x, 0, 1);
}

export function makeSphericalDistribute(
  spherical: Float32Array,
  {
    xMul = 1,
    yMul = 1,
    zMul = 1,
    xAdd = 0,
    yAdd = 0,
    zAdd = 0,
  }: {
    xMul?: number;
    yMul?: number;
    zMul?: number;
    xAdd?: number;
    yAdd?: number;
    zAdd?: number;
  } = {}
) {
  return (_cloud: unknown, index: number) => {
    const x = clamp(spherical[index * 3 + 0] * xMul + xAdd, -1, 1);
    const y = clamp(spherical[index * 3 + 1] * yMul + yAdd, -1, 1);
    const z = clamp(spherical[index * 3 + 2] * zMul + zAdd, -1, 1);
    return { point: new Vector3(x, y, z) };
  };
}

/**
 * Maps a value `t` to its 0–1 position inside the half-open range [start, end].
 * Returns 0 when start == end. Result is clamped to [0, 1].
 */
export function computeSectionProgress(
  t: number,
  start: number,
  end: number,
): number {
  const span = end - start;
  if (span <= 0) return 0;
  return clamp01((t - start) / span);
}
